import {Mention} from 'tiptap-extensions';

export default class CustomMention extends Mention {

    get schema () {
        const customSchema = {
            toDOM: node => {
                window.console.log('Attributes', node.attrs.type);

                return [
                    'a',
                    {
                        class: this.options.mentionClass,
                        'userkey': node.attrs.id,
                        'href': `${node.attrs.id}.html`
                    },
                    node.attrs.label
                ];
            },
            parseDOM: [
                {
                    tag: 'a[userkey]',
                    getAttrs: dom => {
                        const id = dom.getAttribute('userkey');
                        const label = dom.innerText.split(this.options.matcher.char).join('');
                        return {id, label};
                    }
                }
            ]
        };

        return {
            ...super.schema,
            ...customSchema
        };
    }
}
